import { useEffect, useRef, useState } from "react";
import type { Transcript as TranscriptDoc } from "@meeting-notes/shared";

function hms(sec: number) {
  const s = Math.floor(sec);
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), r = s % 60;
  return (h ? `${h}:` : "") + `${String(m).padStart(2, "0")}:${String(r).padStart(2, "0")}`;
}

export function Transcript({ transcriptUrl, audioUrl, speakerLabels }: { transcriptUrl: string; audioUrl: string | null; speakerLabels: Record<string, string> }) {
  const [doc, setDoc] = useState<TranscriptDoc | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [current, setCurrent] = useState(0);
  const audio = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    fetch(transcriptUrl).then(async (r) => (r.ok ? setDoc((await r.json()) as TranscriptDoc) : setError(`전사를 불러오지 못했습니다 (${r.status})`))).catch((e) => setError(String(e)));
  }, [transcriptUrl]);

  if (error) return <p className="text-red-300 text-sm">{error}</p>;
  if (!doc) return <p className="text-slate-400 text-sm">전사 불러오는 중…</p>;
  const colors = ["text-sky-300", "text-emerald-300", "text-amber-300", "text-pink-300", "text-violet-300", "text-lime-300"];
  const speakerIds = Array.from(new Set(doc.segments.map((s) => s.speaker)));
  return (
    <div>
      {audioUrl && (
        <div className="sticky top-0 z-10 bg-slate-950/95 backdrop-blur py-2">
          <audio ref={audio} controls preload="none" src={audioUrl} className="w-full" onTimeUpdate={(e) => setCurrent(e.currentTarget.currentTime)} />
        </div>
      )}
      <ul className="space-y-2 mt-2">
        {doc.segments.map((seg) => {
          const active = current >= seg.start && current < seg.end;
          const color = colors[speakerIds.indexOf(seg.speaker) % colors.length];
          return (
            <li key={seg.id} className={`tap rounded-lg px-3 py-2 ${active ? "bg-slate-800" : ""}`} onClick={() => { if (audio.current) { audio.current.currentTime = seg.start; void audio.current.play(); } }}>
              <div className="flex items-baseline gap-2 text-xs">
                <span className={`font-semibold ${color}`}>{speakerLabels[seg.speaker] ?? seg.speaker}</span>
                <span className="text-slate-500">{hms(seg.start)}</span>
              </div>
              <p className="text-sm text-slate-200 leading-relaxed">{seg.text}</p>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
